import _ from 'lodash'

const deepOmitObjectProperties = (obj, properties) => {
  if (_.isArray(obj)) {
    return obj.map(item => deepOmitObjectProperties(item, properties))
  }
  if (_.isObject(obj)) {
    const cleaned = _.omit(obj, properties)
    return _.mapValues(cleaned, val => deepOmitObjectProperties(val, properties))
  }
  return obj
}

export default deepOmitObjectProperties
